import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import OTPVerify from "../OTPVerify/OTPVerify";
import ForgotPasswordForm from "./ForgotPasswordForm";
import CreatePassword from "../CreatePassword/CreatePassword";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [currentState, setCurrentState] = useState("");
    const [mobileNo, setMobileNo] = useState("");

    const onNextClick = (nextState) => {
        setCurrentState(nextState);
    };

    const currentComponent = () => {
        switch (currentState) {
            case "verifyOtp":
                return (
                    <OTPVerify
                        mobileNo={mobileNo}
                        onCancelClick={() => onNextClick("")}
                        onNextClick={(msg) => onNextClick(msg)}
                    />
                );

            case "createPassword":
                return (
                    <CreatePassword
                        mobileNo={mobileNo}
                        onCancelClick={() => onNextClick("")}
                    />
                )
            default:
                return <ForgotPasswordForm
                    setMobileNo={setMobileNo}
                    onNextClick={(msg) => onNextClick(msg)}
                />;
        }
    };

    return (
        <>
            {currentComponent()}
        </>
    )
}
export default ForgotPassword;